import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { CrearIncidenciaComponent } from "./crear-incidencia/crear-incidencia.component";
import { CrearIncidenciaDialog } from "./crear-incidencia/crear-incidencia-dialog/crear-incidencia-dialog.component";
import { MaterialModule } from "../../components/material/material.module";
import { IncidenciaComponent } from "./incidencia/incidencia.component";
import { VerIncidenciasComponent } from "./ver-incidencias/ver-incidencias.component";
import { IncidenciaService } from "../../providers/incidencia.service";
import { ProspectoService } from "../../providers/prospecto.service";
import { EntidadService } from "../../providers/entidad.service";
import { ClienteService } from "../../providers/cliente.service";
import { VolverModule } from "../../components/volver/volver.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        VolverModule,
    ],
    declarations: [
        CrearIncidenciaComponent,
        CrearIncidenciaDialog,
        IncidenciaComponent,
        VerIncidenciasComponent
    ],
    providers: [
        IncidenciaService,
        ProspectoService,
        EntidadService,
        ClienteService,
    ],
    entryComponents: [
        CrearIncidenciaDialog
    ],
    exports: [
        CrearIncidenciaComponent,
        IncidenciaComponent,
        VerIncidenciasComponent
    ]
})
export class IncidenciaModule { }